<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->

<div class="light-container-popup light-container-tray">
	<ng-template [loadingBlocker]="loadingObservable | async"></ng-template>

	<!-- Header -->
	<div class="light-container__header light-container-tray__header">Procore Link Creation</div>
	<div>To link this constraint to Procore, please choose a link type using the dropdown</div>

	<!-- Content -->
	<div
		class="light-container-popup__content light-container-popup__content--height light-container-popup__content--no-border"
	>
		<div>
			RFI:
			<mat-extended-select
				placeholder="Select an RFI"
				[includeFilter]="true"
				[formControl]="internalField"
				[option$]="itemsObservable"
				[valuePath]="[]"
				[sortCompareFunction]="compareRfiDropdownOptions"
			>
			</mat-extended-select>
		</div>

		<!-- Existing RFI -->
		<div *ngIf="internalField.valueChanges | async">
			<div class="procore-status-item-container">
				Subject
				<div class="procore-status__content-item-data">
					<input [formControl]="subjectControl" type="text" />
				</div>
			</div>

			<div class="procore-status-item-container">
				Question
				<div class="procore-status__content-item-data">
					<textarea [formControl]="descriptionControl"></textarea>
				</div>
			</div>
		</div>
	</div>

	<!-- Footer -->
	<div class="light-container-popup__footer">
		<div class="light-container-popup__footer-buttons-right">
			<button class="legacy-button btn--white close-button" (click)="close()" automationId="cancelButton">
				Cancel
			</button>
			<button class="legacy-button btn--blue" (click)="saveRFI()" automationId="saveButton">Save</button>
		</div>
	</div>
</div>
